<template>
    <div class="wellness-summary">
        <div v-if="dateLabel" class="wellness-date">{{ dateLabel }}</div>
        <div v-for="dimension in dimensions" :key="dimension.key" class="wellness-row">
            <span class="wellness-dot" :style="`background-color: ${dimension.color}`" />
            {{ $t(dimension.labelKey) }}
            <span class="wellness-value">{{ valueOf(dimension.key) }}/{{ max }}</span>
        </div>
    </div>
</template>

<script>
import { wellnessDimensions } from "@/utils/Routine";

export default {
    name: "WellnessSummary",
    props: {
        preInfo: {
            type: Object,
            default: null
        },
        date: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            dimensions: wellnessDimensions,
            max: 5,
        }
    },
    computed: {
        dateLabel(vm = this) {
            if (!vm.date) return ''
            return vm.$moment(vm.date).format('D MMM')
        },
    },
    methods: {
        valueOf(key) {
            return Number(this.preInfo?.[key] || 0)
        },
    }
}
</script>

<style scoped>
.wellness-date {
    font-size: 10px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: .08em;
    margin-bottom: 10px;
}

.wellness-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    white-space: nowrap;
}

.wellness-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.wellness-value {
    font-weight: 800;
    color: var(--v-txtPrimary-base);
    margin-left: auto;
    padding-left: 18px;
}
</style>
